/**
 * Rovers Controller
 * Defines the interface for our Rovers Object
 * Rovers are the representation of all the rovers and simulations we have for the user to control
 */

// Import API singleton and appropriate resource interface
import api, { resolveWithStatus } from "@/services/api/api";

const index = async () => {
  try {
    const rovers = (await api.get("/rovers")).data;

    return rovers;
  } catch (error) {
    console.log("Request Failed");
    console.log(error);

    throw error;
  }
};

const show = async (id: string) => {
  try {
    const response = await api.get(`/rovers/${id}/`);

    return response.data;
  } catch (error) {
    console.log("Failed to send the request");
    console.log(error);
    throw error;
  }
};

//  Export all action
export default {
  index,
  show
};
